import React from 'react'
import './index.css'

const NavBar = () => {
  return (
    <div className="navbar-container">
      <img src="image/Logo.svg" alt="#" />
    </div>
  )
}

export default NavBar
